import { isSampleAnalyzing } from "../../../../util";
import { RLcsAnalysisResponseData } from "../../../rlcloudsandbox/hooks/useRlcsAnalysisStatus";

export const getCloudSandboxAnalyzingCount = (
  status?: RLcsAnalysisResponseData
) => {
  const { automated, interactive } = status ?? {};
  const isAutomatedAnalyzing = isSampleAnalyzing(automated?.display_status);
  const isInteractiveAnalyzing = isSampleAnalyzing(interactive?.display_status);

  return [isAutomatedAnalyzing, isInteractiveAnalyzing].filter(Boolean).length;
};
